<template>
    <section>
        <Feed></Feed>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Feed from '@/views/Feed';

    export default {
        name: 'Home',
        components: {
            Feed
        },
        watch: {
            '$route' (to, from) {
                if (
                    this.$route.params &&
                    this.$route.params.uid &&
                    this.$route.params.token
                ) {
                    this.$modal.show('new-password', {
                        uid: this.$route.params.uid,
                        token: this.$route.params.token
                    });
                    this.$router.push({name: 'home'});
                }
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/fetchUser',
                isEmpty: 'user/isEmpty',
                showRegister: 'user/fetchRegister'
            })
        },
        created() {
            if (
                this.$route.params &&
                this.$route.params.uid &&
                this.$route.params.token
            ) {
                this.$modal.show('new-password', {
                    uid: this.$route.params.uid,
                    token: this.$route.params.token
                });
                this.$router.push({name: 'home'});
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/styles/layout/_auth';
</style>
